<dx-toolbar class="theme-dependent">
    <dxi-item location="before">
        <div class="header-text">{{ number ? 'Edit' : 'New' }}</div>
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canExport">
        <dx-button text="Export" stylingMode="outlined" type="normal" [disabled]="isExporting"
            (onClick)="exportClick.emit()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never">
        <dx-button text="Cancel" stylingMode="outlined" type="normal" (onClick)="cancelClick.emit()" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoiceAction.SaveAsDraft)">
        <dx-button text="Save As Draft" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoiceAction.SaveAsDraft)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoiceAction.Save)">
        <dx-button text="Save" type="default" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoiceAction.Save)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoiceAction.Submit)">
        <dx-button text="Submit" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoiceAction.Submit)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoiceAction.ApproveL1)">
        <dx-button text="Approve" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoiceAction.ApproveL1)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoiceAction.ApproveL2)">
        <dx-button text="Approve" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoiceAction.ApproveL2)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoiceAction.ApproveL3)">
        <dx-button text="Approve" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoiceAction.ApproveL3)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoiceAction.Posted)">
        <dx-button text="Posted" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoiceAction.Posted)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoiceAction.InvestigationCompleted)">
        <dx-button text="Investigation Completed" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoiceAction.InvestigationCompleted)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="canShowButton(InvoiceAction.ResumeInvoice)">
        <dx-button text="Resume Invoice" type="success" stylingMode="contained" [disabled]="isSubmitting"
            (onClick)="onButtonClick(InvoiceAction.ResumeInvoice)" class="ms-2" />
    </dxi-item>
    <dxi-item location="after" locateInMenu="never" [visible]="showMoreMenu">
        <dx-drop-down-button text="More" icon="overflow" [dropDownOptions]="{ width: 210 }" [items]="moreMenuActions"
            [splitButton]="false" stylingMode="outlined" type="default" displayExpr="text" keyExpr="id"
            [disabled]="isSubmitting" (onItemClick)="onMenuActionClick($event)" class="ms-2">
        </dx-drop-down-button>
    </dxi-item>
</dx-toolbar>